import {Route, Routes, useNavigate} from "react-router-dom";
import {SurveyView} from "./views/survey";
import {LoginView} from "./views/auth";
import {SurveyListView} from "./views/list";
import {UnauthorizedView} from "./views/errors/401";
import {NotFoundViewView} from "./views/errors/404";
import {InternalErrorViewView} from "./views/errors/500";
import {useAxiosInterceptors} from "./data/api/axiosInterceptors";
import {ResponseItem} from "./views/responses/item";


export function App() {

    const navigate = useNavigate();

    useAxiosInterceptors(navigate);

    return (
        <Routes>
            <Route
                path="auth/login"
                element={<LoginView />}
            />
            <Route
                path="survey/:id"
                element={<SurveyView />}
            />
            <Route
                path="survey/list"
                element={<SurveyListView />}
            />
            <Route
                path="responses/:id"
                element={<ResponseItem />}
            />
            <Route
                path="unauthorized"
                element={<UnauthorizedView />}
            />
            <Route
                path="not-found"
                element={<NotFoundViewView />}
            />
            <Route
                path="internal-error"
                element={<InternalErrorViewView />}
            />
        </Routes>
    );
}

export default App;